import { render } from "./ClientManagerSideMenu.vue?vue&type=template&id=3e31c186"
import script from "./ClientManagerSideMenu.vue?vue&type=script&lang=js"
export * from "./ClientManagerSideMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__